import { Badge } from "antd"
import classNames from "classnames"
import { FC } from "react"
import styles from '../../styles/icons.module.scss'

export const NewsChatIcon: FC<ISvgProps> = ({ count, ...props }) => {
    return <>
        <Badge
            className={styles.badge}
            size="small"
            count={count || 0}
            overflowCount={count && count <= 1000 ? 99 : 999}
            offset={[-8, 8]}
            style={{
                color: '#ff4d4f',
                backgroundColor: '#fff',
                border: '0.5px solid #ff4d4f',
                boxShadow: '0 0 0 1px #ff4d4f',
            }}
        >
            <svg className={classNames(styles.svg, props.className)} width="64px" height="64px" viewBox="-6.4 -6.4 76.80 76.80" xmlns="http://www.w3.org/2000/svg" stroke-width="3" stroke="#000000" fill="none" transform="rotate(0)matrix(-1, 0, 0, 1, 0, 0)">
                <g id="SVGRepo_bgCarrier" stroke-width="0" />
                <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round" stroke="#CCCCCC" stroke-width="0.512" />
                <g id="SVGRepo_iconCarrier">
                    <path d="M53.85,43.71H28.6l-10.75,8,.1-8H10.09a2,2,0,0,1-2-2V12.78a2,2,0,0,1,2-2H53.91a2,2,0,0,1,2,2V41.65A2.06,2.06,0,0,1,53.85,43.71Z" />
                    <line x1="14.31" y1="18.91" x2="45.08" y2="18.91" />
                    <line x1="14.31" y1="26.33" x2="32.17" y2="26.33" />
                    <line x1="14.31" y1="33.75" x2="38.58" y2="33.75" />
                </g>
            </svg>
        </Badge>
    </>
}